import './assets/current-student-advanced-standing-form.scss'

import { createPinia } from 'pinia'
import { createApp } from 'vue'
import CurrentStudentAdvancedStandingFormApp from './CurrentStudentAdvancedStandingFormApp.vue'

const pinia = createPinia()

createApp(CurrentStudentAdvancedStandingFormApp).use(pinia).mount('#student-form-vue-app')
